import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "fw-bold" }
const _hoisted_2 = { class: "fst-italic" }
const _hoisted_3 = ["data-id", "value", "checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "title")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "message")
    ]),
    _createElementVNode("table", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chunks, (chunk) => {
        return (_openBlock(), _createElementBlock("tr", { key: chunk }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chunk, (item) => {
            return (_openBlock(), _createElementBlock("td", { key: item }, [
              _createElementVNode("label", null, [
                _createElementVNode("input", {
                  class: "radio-button",
                  type: "radio",
                  name: "casing",
                  "data-id": item.id,
                  value: item.value,
                  checked: this.preferredCasing === item.value
                }, null, 8, _hoisted_3),
                _createTextVNode(" " + _toDisplayString(item.label), 1)
              ])
            ]))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}